import { POST } from "./index";
import {
  ConfigRequest,
  ConfigResponse,
  UserFinanceDataResponse,
} from "@/types/financeData";

// Re-export types for convenience
export type {
  IncomeSource,
  IncomeAnalysis,
  CategorySpending,
  MerchantSpending,
  SpendingAnalysis,
  CategoryBudget,
  DailyNetWorth,
  NetWorthAnalysis,
  SavingsGoal,
  FinanceAnalysis,
  ConfigRequest,
  ConfigResponse,
  AccountSummary,
  UserFinanceDataResponse,
} from "@/types/financeData";

const UserFinanceDataServices = {
  /**
   * Get user finance data including accounts and analysis
   * @returns Promise<ApiResponse<UserFinanceDataResponse>>
   */
  get: async () => {
    return await POST<UserFinanceDataResponse>("/user-finance-data/get");
  },

  /**
   * Update user finance configuration (income, budget, categories)
   * @param config - Configuration to update
   * @returns Promise<ApiResponse<ConfigResponse>>
   */
  config: async (config: ConfigRequest) => {
    return await POST<ConfigResponse>("/user-finance-data/config", config);
  },
};

export default UserFinanceDataServices;
